import { createContext, useContext } from 'react';

export const AppContext = createContext(null);

// Shared hook keeps language and theme access consistent across components.
export function useApp() {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error('useApp must be used inside AppProvider.');
  }

  return context;
}
